import orderBy from 'lodash/orderBy';
import React, { useCallback, useMemo } from 'react';
import { CHAT_FLOW_STEPS, useCurrentChat } from '@guuru/chat-web';
import Option from '../../Option';
import ChatRenderText from '../Text';

interface ChatRenderCategoriesProps {
  message: React.ComponentProps<typeof ChatRenderText>['message'] & {
    metadata: {
      categories: {
        id: string;
        name: string;
        priority: number;
      }[];
    };
  };
  readOnly: boolean;
  locale?: string;
  onRunNextStep?: (_: { category: string; categoryLabel: string }) => void;
}

const ChatRenderCategories = function ({
  message,
  locale = 'en',
  readOnly,
  onRunNextStep = () => {},
}: ChatRenderCategoriesProps) {
  const { flowStep } = useCurrentChat();
  const categories = message?.metadata?.categories;

  const handleSelection = useCallback(
    (category: string, categoryLabel: string) => {
      onRunNextStep({
        category,
        categoryLabel,
      });
    },
    [onRunNextStep],
  );

  const sortedCategories = useMemo(
    () => orderBy(categories, 'priority'),
    [categories],
  );

  const showOptions =
    !readOnly &&
    flowStep === CHAT_FLOW_STEPS.requestCategory &&
    sortedCategories.length > 0;

  return (
    <ChatRenderText message={message} tooltip={false}>
      {showOptions && (
        <ul role="menu" aria-label="categories">
          {sortedCategories.map((category) => (
            <Option
              key={category.id}
              id={category.id}
              name={category.name}
              locale={locale}
              onClick={handleSelection}
            />
          ))}
        </ul>
      )}
    </ChatRenderText>
  );
};

export default ChatRenderCategories;
